import config from "../boot/config";
import http from "../boot/http.js";
import { DateTime } from "../utils";
import moment from "moment-timezone";

const route = "Evidence/";

export default class {
   static AddNewImplementedChange(dto) {
      let url = `${config.baseUrl + route}AddNewImplementedChange`;

      let newPayload = {...dto, date: DateTime.toISOstring(moment(dto.date).utc().add(moment(dto.date).utcOffset(), 'm'))};

      return http({ url, method: "POST", data: newPayload})
            .then(data => data)
            .catch(error => error);
   }

   static AddNewPreSetTests(dto) {
      let url = `${config.baseUrl + route}AddNewPreSetTests`;

      let newPayload = {...dto, dates: [], date: DateTime.toISOstring(moment(dto.date).utc().add(moment(dto.date).utcOffset(), 'm'))};
      
      dto.dates.forEach(d => {
            newPayload.dates.push(DateTime.toISOstring(moment(d).utc().add(moment(d).utcOffset(), 'm')));
      });

      return http({ url, method: "POST", data: newPayload})
            .then(data => data)
            .catch(error => error);
   }

   static AddNewComment(dto) {
      let url = `${config.baseUrl + route}AddNewComment`;

      let newPayload = {...dto, date: DateTime.toISOstring(moment(dto.date).utc().add(moment(dto.date).utcOffset(), 'm'))};

      return http({ url, method: "POST", data: newPayload})
            .then(data => data)
            .catch(error => error);
   }

   static GetPreSetTestById(preSetTestId) {
      if(!preSetTestId) {
            return;
      }
      let url = `${config.baseUrl + route}GetPreSetTestById`;

      return http({ url, method: "GET", preSetTestId: preSetTestId})
         .then(data => data)
         .catch(error => error);  
   }

   static GetPreSetTestsBySiteName(siteName, fromDate, toDate) {
      if(!siteName || !fromDate || !toDate) {
            return;
      }
      let url = `${config.baseUrl + route}GetPreSetTestsBySiteName`;
      
      var adjustedFrom = moment(fromDate).utc().add(moment(fromDate).utcOffset(), 'm');
      var adjustedTo = moment(toDate).utc().add(moment(toDate).utcOffset(), 'm');

      const fromDateString = DateTime.toISOstring(adjustedFrom);
      const toDateString = DateTime.toISOstring(adjustedTo);

      return http({ url, method: "GET", siteName: siteName, fromDate: fromDateString, toDate: toDateString})
         .then(data => data)
         .catch(error => error);  
   }

   static GetImplementedChangeById(implementedChangeId) {
      if(!implementedChangeId) {
            return;
      }
      let url = `${config.baseUrl + route}GetImplementedChangeById`;

      return http({ url, method: "GET", implementedChangeId: implementedChangeId})
         .then(data => data)
         .catch(error => error);  
   }

   static GetImplementedChangesBySiteName(siteName, fromDate, toDate) {
      if(!siteName || !fromDate || !toDate) {
            return;
      }
      let url = `${config.baseUrl + route}GetImplementedChangesBySiteName`;
      
      var adjustedFrom = moment(fromDate).utc().add(moment(fromDate).utcOffset(), 'm');
      var adjustedTo = moment(toDate).utc().add(moment(toDate).utcOffset(), 'm');

      const fromDateString = DateTime.toISOstring(adjustedFrom);
      const toDateString = DateTime.toISOstring(adjustedTo);

      return http({ url, method: "GET", siteName: siteName, fromDate: fromDateString, toDate: toDateString})
         .then(data => data)
         .catch(error => error);  
   }

   static GetImplementedChangeDates(implementedChangeId) {
         if(!implementedChangeId) {
               return;
         }

         let url = `${config.baseUrl + route}GetImplementedChangeDates`;

         return http({url, method: "GET"})
            .then(data => data)
            .catch(error => error);
   }

   static GetDailyFailedRuleCountBySiteName(siteName, fromDate, toDate) {
      if(!siteName || !fromDate || !toDate) {
            return;
      }
      let url = `${config.baseUrl + route}GetDailyFailedRuleCountBySiteName`;
      
      var adjustedFrom = moment(fromDate).utc().add(moment(fromDate).utcOffset(), 'm');
      var adjustedTo = moment(toDate).utc().add(moment(toDate).utcOffset(), 'm');

      const fromDateString = DateTime.toISOstring(adjustedFrom);
      const toDateString = DateTime.toISOstring(adjustedTo);

      return http({ url, method: "GET", siteName: siteName, fromDate: fromDateString, toDate: toDateString})
         .then(data => data)
         .catch(error => error);
   }

   static GetAutomatedActionsBySiteName(siteName, fromDate, toDate) {
      if(!siteName || !fromDate || !toDate) {
            return;
      }
      let url = `${config.baseUrl + route}GetAutomatedActionsBySiteName`;
      
      var adjustedFrom = moment(fromDate).utc().add(moment(fromDate).utcOffset(), 'm');
      var adjustedTo = moment(toDate).utc().add(moment(toDate).utcOffset(), 'm');

      const fromDateString = DateTime.toISOstring(adjustedFrom);
      const toDateString = DateTime.toISOstring(adjustedTo);

      return http({ url, method: "GET", siteName: siteName, fromDate: fromDateString, toDate: toDateString})
         .then(data => data)
         .catch(error => error);
   }

   static GetDiagnosticRulesBySiteName(siteName, fromDate, toDate) {
      if(!siteName || !fromDate || !toDate) {
            return;
      }
      let url = `${config.baseUrl + route}GetDiagnosticRulesBySiteName`;
      
      var adjustedFrom = moment(fromDate).utc().add(moment(fromDate).utcOffset(), 'm');
      var adjustedTo = moment(toDate).utc().add(moment(toDate).utcOffset(), 'm');

      const fromDateString = DateTime.toISOstring(adjustedFrom);
      const toDateString = DateTime.toISOstring(adjustedTo);

      return http({ url, method: "GET", siteName: siteName, fromDate: fromDateString, toDate: toDateString})
         .then(data => data)
         .catch(error => error);
   }

   static GetLearnedRuleChangesBySiteName(siteName, fromDate, toDate) {
      if(!siteName || !fromDate || !toDate) {
            return;
      }
      let url = `${config.baseUrl + route}GetLearnedRuleChangesBySiteName`;
      
      var adjustedFrom = moment(fromDate).utc().add(moment(fromDate).utcOffset(), 'm');
      var adjustedTo = moment(toDate).utc().add(moment(toDate).utcOffset(), 'm');

      const fromDateString = DateTime.toISOstring(adjustedFrom);
      const toDateString = DateTime.toISOstring(adjustedTo);

      return http({ url, method: "GET", siteName: siteName, fromDate: fromDateString, toDate: toDateString})
         .then(data => data)
         .catch(error => error);
   }

   static GetFailedRuleInstanceSummaryListBySiteName(siteName, fromDate, toDate) {
      if(!siteName || !fromDate || !toDate) {
            return;
      }
      let url = `${config.baseUrl + route}GetFailedRuleInstanceSummaryListBySiteName`;
      
      var adjustedFrom = moment(fromDate).utc().add(moment(fromDate).utcOffset(), 'm');
      var adjustedTo = moment(toDate).utc().add(moment(toDate).utcOffset(), 'm');

      const fromDateString = DateTime.toISOstring(adjustedFrom);
      const toDateString = DateTime.toISOstring(adjustedTo);

      return http({ url, method: "GET", siteName: siteName, fromDate: fromDateString, toDate: toDateString})
         .then(data => data)
         .catch(error => error);
   }

   static GetCommentsBySiteName(siteName, fromDate, toDate) {
      if(!siteName || !fromDate || !toDate) {
            return;
      }
      let url = `${config.baseUrl + route}GetCommentsBySiteName`;
      
      var adjustedFrom = moment(fromDate).utc().add(moment(fromDate).utcOffset(), 'm');
      var adjustedTo = moment(toDate).utc().add(moment(toDate).utcOffset(), 'm');

      const fromDateString = DateTime.toISOstring(adjustedFrom);
      const toDateString = DateTime.toISOstring(adjustedTo);

      return http({ url, method: "GET", siteName: siteName, fromDate: fromDateString, toDate: toDateString})
         .then(data => data)
         .catch(error => error);
   }

   static UpdateImplementedChange(dto, editDto) {
      let url = `${config.baseUrl + route}UpdateImplementedChange`;
      
      let newPayload = {...dto, editDto: editDto};
      var date = moment(newPayload.date).add(moment(newPayload.date).utcOffset(),'m');
      newPayload.date = DateTime.toISOstring(date);

      return http({ url, method: "POST", data: newPayload})
            .then(data => data)
            .catch(error => error);
   }

   static UpdatePreSetTest(dto, editDto) {
      let url = `${config.baseUrl + route}UpdatePreSetTest`;
      let newPayload = {...dto, dates: [], date: DateTime.toISOstring(dto.date), editDto: editDto};
      
      dto.dates.forEach(d => {
            newPayload.dates.push(DateTime.toISOstring(d));
      });

      return http({ url, method: "POST", data: newPayload})
            .then(data => data)
            .catch(error => error);
   }

   static UpdateComment(dto, editDto) {
      let url = `${config.baseUrl + route}UpdateComment`;
      
      let newPayload = {...dto, editDto: editDto};

      return http({ url, method: "POST", data: newPayload})
            .then(data => data)
            .catch(error => error);
   }

   static DeleteImplementedChange(implementedChangeId) {
      let url = `${config.baseUrl + route}DeleteImplementedChange`;

      return http({ url, method: "POST", implementedChangeId})
            .then(data => data)
            .catch(error => error);
   }

   static DeletePreSetTest(preSetTestId) {
      let url = `${config.baseUrl + route}DeletePreSetTest`;

      return http({ url, method: "POST", preSetTestId})
            .then(data => data)
            .catch(error => error);
   }

   static DeleteComment(commentId) {
      let url = `${config.baseUrl + route}DeleteComment`;

      return http({ url, method: "POST", commentId})
            .then(data => data)
            .catch(error => error);
   }

   static GetEvidenceListYears(type, siteName) {
      let url = `${config.baseUrl + route}GetEvidenceListYears`;

      return http({url, method: "GET", type, siteName})
            .then(data => data)
            .catch(error => error);
   }

   static GetEvidenceListMonths(type, siteName, year) {
      let url = `${config.baseUrl + route}GetEvidenceListMonths`;

      return http({url, method: "GET", type, siteName, year})
            .then(data => data)
            .catch(error => error);
   }

   static GetEvidenceListDays(type, siteName, year, month) {
      let url = `${config.baseUrl + route}GetEvidenceListDays`;

      return http({url, method: "GET", type, siteName, year, month})
            .then(data => data)
            .catch(error => error);
   }

   static GetEvidenceListIndividuals(type, siteName, year, month, day) {
      let url = `${config.baseUrl + route}GetEvidenceListIndividuals`;

      return http({url, method: "GET", type, siteName, year, month, day})
            .then(data => data)
            .catch(error => error);
   }

   static GetEvidenceListSearch(type, siteName, query) {
         let url = `${config.baseUrl + route}GetEvidenceListSearch`;

         return http({url, method: "GET", type, siteName, query})
            .then(data => data)
            .catch(error => error);
   }

   static GetEvidenceListFlat(type, siteName) {
      let url = `${config.baseUrl + route}GetEvidenceListFlat`;

      return http({url, method: "GET", type, siteName})
         .then(data => data)
         .catch(error => error);
   }
}



// WEBPACK FOOTER //
// ./src/services/evidence.js